module.exports = __WEBPACK_EXTERNAL_MODULE_10__;


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
// module id = 10
// module chunks = 0